import React, { useEffect, useState, useRef } from 'react';
import { FaChartBar, FaFilePdf } from 'react-icons/fa';
import Payments from './payments';
import TrialBalance from './trialBalance';
import CashBook from './cash';
import DetailedIncomeStatement from './income';
import { rootUrl } from '../../../helpers';
import axios from 'axios';
import { useAuth } from '../../../context/auth-context';
import BalanceSheet from './balance';
// import ReactToPrint from 'react-to-print';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Ipsas from './ipsas';
import BankReconciliation from './bankrec';
import Receipts from './receipts';
import Projects from './projects';


export default function Reports() {
  const [activeTab, setActiveTab] = useState('randc');
  const [activeSection, setActiveSection] = useState('reports1');
  const [rdata, setData] = useState([]);
  const auth = useAuth();
  const componentRef = useRef();

  const fetchData = async () => {
    try {
      const response = await axios.get(rootUrl(`/trialBalance/${auth.user.cid}`));
      setData(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function handleExportToPDF() {
    const input = componentRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${activeTab}.pdf`);
    });
  }
  const renderContent = () => {
    switch (activeTab) {
      case 'randc':
        return <TabbedComponent />;
      case 'tb':
        return <TrialBalance rdata={rdata} />;
      case 'cash':
        return <CashBook />;
      case 'income':
        return <DetailedIncomeStatement rdata={rdata} />;
      case 'balance':
        return <BalanceSheet rdata={rdata} />;
      case 'bank':
        return <BankReconciliation />;
      case 'ipsas':
        return <Ipsas rdata={rdata} />;
      case 'projects':
        return <Projects />;
      default:
        return <div>Welcome to Reports</div>;
    }
  };

  return (
    <div>
      <div className="flex w-full items-center justify-between border-b pb-4">
        <div>
          <h1 className="text-[25px] text-slate-800 font-bold flex items-center">
            <FaChartBar className="mr-2" /> Reports
          </h1>
        </div>
      </div>

      {/* Section Selector */}
      <div className="flex justify-center my-4">
        <button
          onClick={() => setActiveSection('reports1')}
          className={`px-4 py-2 mx-2 ${activeSection === 'reports1' ? 'bg-blue-900 text-white' : 'bg-gray-200'}`}
        >
          Reports 1
        </button>
        <button
          onClick={() => setActiveSection('reports2')}
          className={`px-4 py-2 mx-2 ${activeSection === 'reports2' ? 'bg-blue-900 text-white' : 'bg-gray-200'}`}
        >
          Reports 2
        </button>
      </div>

      {/* Tabs for Reports 1 */}
      {activeSection === 'reports1' && (
        <nav className="grid grid-cols-4 m-3 rounded-2xl shadow-lg bg-gray-200 my-5">
          <button
            onClick={() => setActiveTab('randc')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'randc' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Receipts/Payments
          </button>
          <button
            onClick={() => setActiveTab('tb')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'tb' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Trial Balance
          </button>
          <button
            onClick={() => setActiveTab('cash')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'cash' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Cash
          </button>
          <button
            onClick={() => setActiveTab('income')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'income' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Income Statement
          </button>
        </nav>
      )}

      {/* Tabs for Reports 2 */}
      {activeSection === 'reports2' && (
        <nav className="grid grid-cols-4 m-3 rounded-2xl shadow-lg bg-gray-200 my-5">
          <button
            onClick={() => setActiveTab('balance')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'balance' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Balance
          </button>
          <button
            onClick={() => setActiveTab('bank')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'bank' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Bank Recon
          </button>
          <button
            onClick={() => setActiveTab('projects')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'projects' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Projects
          </button>
          <button
            onClick={() => setActiveTab('ipsas')}
            className={`cursor-pointer py-2 font-semibold flex items-center justify-center ${activeTab === 'ipsas' ? 'bg-white rounded-2xl px-2' : ''}`}
          >
            Ipsas
          </button>
          
        </nav>
      )}

      {/* Export to PDF Button */}
      <button
        onClick={handleExportToPDF}
        className="px-4 py-2 m-4 bg-blue-900 text-white rounded-md float-right"
      >
        <FaFilePdf />
      </button>

      {/* Content Section */}
      <div className="mt-6" ref={componentRef}>
        {renderContent()}
      </div>
    </div>
  );
}

const TabbedComponent = () => {
  const [activeTab, setActiveTab] = useState("payments");

  return (
    <div>
      {/* Tab Navigation */}
      <div className="tabs">
        <button
          className={`tab-button ${activeTab === "payments" ? "active" : ""}`}
          onClick={() => setActiveTab("payments")}
        >
          By COA
        </button>
        <button
          className={`tab-button ${activeTab === "receipts" ? "active" : ""}`}
          onClick={() => setActiveTab("receipts")}
        >
          By Program
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "payments" && <Payments />}
        {activeTab === "receipts" && <Receipts />}
      </div>

      {/* Styles (for demonstration) */}
      <style jsx>{`
        .tabs {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
          justify-content: center;
        }
        .tab-button {
          padding: 0.5rem 1rem;
          border: none;
          cursor: pointer;
          background-color: #f0f0f0;
          border-radius: 4px;
          font-weight: bold;
          transition: background-color 0.3s, color 0.3s;
        }
        .tab-button.active {
          background-color: #007bff;
          color: #fff;
        }
        .tab-content {
          padding: 1rem;
          border: 1px solid #ddd;
          border-radius: 4px;
          background-color: #fff;
        }
      `}</style>
    </div>
  );
};

